import { environment as env } from '../../../../../environments/environment';


const SAT_BASE_URL = env.ApiUrl + 'v1/'; //
const REPORTING_URL = env.ApiUrl + 'api'; // env.ReportingUrl;

export const SAT_ENDPOINTS = {
  list: SAT_BASE_URL + 'sat_schedule/list',
  item: SAT_BASE_URL + 'sat_schedule/{id}',
  baseInstant: SAT_BASE_URL + 'instant_sendsat',
  baseProgramado: SAT_BASE_URL + 'sat_schedule',
  // activation: SAT_BASE_URL + '/{id}/activationToggle',
  idNames:  REPORTING_URL + '/organization/{id}/operator',
  // itemIdNames: SAT_BASE_URL + '/{id}/items/idNames'
  getReportingData: REPORTING_URL + '/reporting/campaign/{id}',
};

